/*/
 * Animated scroll
/*/
	const siteScroll = _ => {
		const scrollElements = document.querySelectorAll('[site-reveal]')
		const scrollObserver = new IntersectionObserver((entries, observer) => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					entry.target.classList.add('is--revealed')
				} else {
					entry.target.classList.remove('is--revealed')
				}
			})
		}, {
			threshold: 0,
			rootMargin: '25px 25px 25px 25px'
		})

		scrollElements.forEach(target => scrollObserver.observe(target))
	}


window.addEventListener('load', function () {
	setTimeout(() => {
		siteScroll()
	}, 500)
})

/*/
 * Back to top
/*/
	const siteBackToTop = _ => {
		const scrollElements = document.querySelectorAll('[site-top-scroll]')
		const scrollObserver = new IntersectionObserver((entries, observer) => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					document.documentElement.classList.add('is--back-to-top')
				} else {
					document.documentElement.classList.remove('is--back-to-top')
				}
			})
		}, {
			threshold: 0,
			rootMargin: '25px 25px 25px 25px'
		})

		scrollElements.forEach(target => scrollObserver.observe(target))
	}

	window.addEventListener('load', function () {
		setTimeout(() => {
			siteBackToTop()
		}, 500)
	})
